<button type="button" class="__dropdown-button">
  <span class="__dropdown-button-contents">
    <span class="__dropdown-button-text">
      {{buttonText}}
    </span>
    <span class="__dropdown-button-badge" *ngIf="buttonBadge !== ''">
      {{buttonBadge}}
    </span>
  </span>
  <awair-caret-down-icon></awair-caret-down-icon>
</button>
<ul class="__dropdown-ul">
  <ng-content></ng-content>
</ul>
